const CLEAN = 'all/CLEAN';
// STEPS
const SET_STEPS_LIST = 'steps/SET_STEPS_LIST';
const INCREASE_STEP = 'steps/INCREASE_STEP';
const DECREASE_STEP = 'steps/DECREASE_STEP';
const SET_INNER_PAGES_LIST = 'steps/SET_INNER_PAGES_LIST';
const SET_STEP_INNER_PAGE = 'steps/SET_STEP_INNER_PAGE';
const SHOW_ERROR = 'steps/SHOW_ERROR';
const SHOW_LOADING = 'steps/SHOW_LOADING';
const SHOW_INNER_LOADING = 'steps/SHOW_INNER_LOADING';
// OPTIONS
const SET_OPTIONS_VALUE = 'options/SET_OPTIONS_VALUE';
const SET_OPTIONS_LIST = 'options/SET_OPTIONS_LIST';
// CLIENT
const SET_CLIENT_VALUE = 'client/SET_CLIENT_VALUE';
// HOME
const SET_HOME_VALUE = 'home/SET_HOME_VALUE';
// APERSONAL
const SET_APERSONAL_VALUE = 'apersonal/SET_APERSONAL_VALUE';
// PYME
const SET_PYME_VALUE = 'pyme/SET_PYME_VALUE';
const SET_PYME_LIST = 'pyme/SET_PYME_LIST';
// VEHICLES
const SET_VEHICLES_VALUE = 'vehicles/SET_VEHICLES_VALUE';
const GO_BACK_AUTO = 'vehicles/GO_BACK_AUTO';
// YATES
const SET_YATES_VALUE = 'yates/SET_YATES_VALUE';
// QUOTATION
const SET_OPTIONAL_QUOTATION_VALUE = 'SET_OPTIONAL_QUOTATION_VALUE';
const SET_QUOTATION = 'quotation/SET_QUOTATION';
const CLEAN_QUOTATION = 'quotation/CLEAN_QUOTATION';
const CLEAN_QUOTATION_ERROR = 'quotation/CLEAN_QUOTATION_ERROR';
// PAYMENT
const SET_CREDIT_CARD = 'payment/SET_CREDIT_CARD';
const SET_INSTALLMENTS = 'payment/SET_INSTALLMENTS';
const CLEAN_INSTALLMENTS = 'payment/CLEAN_INSTALLMENTS';
const SET_PAYMENT_VALUE = 'payment/SET_PAYMENT_VALUE';
const TOGGLE_TERMS_CHECK = 'payment/TOGGLE_TERMS_CHECK';
// GTIA ALQUILER
const SET_RENTAL_VALUE = 'rental/SET_RENTAL_VALUE';
// SALUD
const SET_HEALTH_VALUE = 'rental/SET_HEALTH_VALUE';
const SET_PERSON_BIRTHDATE = 'rental/SET_PERSON_BIRTHDATE';
const SET_QUOTATION_SALUD = 'rental/SET_QUOTATION_SALUD';

export default {
  CLEAN,
  // STEPS
  SET_STEPS_LIST,
  INCREASE_STEP,
  DECREASE_STEP,
  SET_INNER_PAGES_LIST,
  SET_STEP_INNER_PAGE,
  SHOW_ERROR,
  SHOW_LOADING,
  SHOW_INNER_LOADING,
  // OPTIONS
  SET_OPTIONS_VALUE,
  SET_OPTIONS_LIST,
  // CLIENT
  SET_CLIENT_VALUE,
  // HOME
  SET_HOME_VALUE,
  // APERSONAL
  SET_APERSONAL_VALUE,
  // PYME
  SET_PYME_VALUE,
  SET_PYME_LIST,
  // VEHICLES
  SET_VEHICLES_VALUE,
  GO_BACK_AUTO,
  // YATES
  SET_YATES_VALUE,
  // QUOTATION
  SET_OPTIONAL_QUOTATION_VALUE,
  SET_QUOTATION,
  CLEAN_QUOTATION,
  CLEAN_QUOTATION_ERROR,
  // PAYMENT
  SET_CREDIT_CARD,
  SET_INSTALLMENTS,
  CLEAN_INSTALLMENTS,
  SET_PAYMENT_VALUE,
  TOGGLE_TERMS_CHECK,
  // GTIA ALQUILER
  SET_RENTAL_VALUE,
  // SALUD
  SET_HEALTH_VALUE,
  SET_PERSON_BIRTHDATE,
  SET_QUOTATION_SALUD
};
